'use client'

import { useQuery } from '@tanstack/react-query'
import services from '../services'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { GetUserSearchParams } from '@/shared/api/end-points/user'
import { ProjectSearchResponse } from '../../lib'

type UseGetUserSearchParams = GetUserSearchParams & {
  enabled?: boolean
}

const defaultData: ProjectSearchResponse = {
  estimatedTotalHits: 0,
  limit: 20,
  offset: 0,
  query: null,
  entityType: null,
  hits: [],
}

const useGetUserSearch = ({ enabled = true, ...params }: UseGetUserSearchParams) => {
  const queryKey = [queryKeys((a, m) => a.user.getUserSearch(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getUserSearch(params)),
    enabled,
    refetchOnWindowFocus: false,
  })

  return {
    ...query,
    queryKey,
    data: query.data || defaultData,
  }
}

export default useGetUserSearch
